<template>
  <!-- drawer school add -->
  <el-drawer
    :title="editorText + '学校'"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    direction="rtl"
    :show-close="false"
    @open="handleOpen"
  >
    <el-form label-width="120px" :rules="rules" ref="form" :model="form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="学校名称" prop="name">
            <el-input
              v-model.trim="form.name"
              :maxlength="20"
              placeholder="请输入学校名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="信用代码" prop="credit">
            <el-input
              v-model.trim="form.credit"
              :maxlength="20"
              placeholder="请输入信用代码"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="上级机构" prop="upDepart">
            <el-select
              placeholder="请选择"
              v-model="form.upDepart"
              :disabled="editing"
              clearable
            >
              <el-option
                v-for="item in upDeparts"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属学段" prop="mode">
            <el-select
              placeholder="请选择"
              v-model="form.mode"
              :disabled="editing"
              clearable
            >
              <el-option
                v-for="item in modes"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="办学模式" prop="banxue">
            <el-select
              placeholder="请选择"
              v-model="form.banxue"
              clearable
            >
              <el-option
                v-for="item in banxues"
                :key="item.value"
                :label="item.name"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="办学性质" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio :label="1">公办</el-radio>
              <el-radio :label="2">民办</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="submitting"
        @click="submitForm('form')"
        >确 定</el-button
      >
    </div>
  </el-drawer>
</template>

<script>
// import _ from 'lodash'
import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible'],
  data () {
    var validateName = (rule, value, callback) => {
      if (value.replace(/[\u4e00-\u9fa5]/g, '').length !== 0) {
        callback(new Error('学校名称仅支持中文字符'))
      } else {
        callback()
      }
    }
    var validateCredit = (rule, value, callback) => {
      if (
        /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(value) ===
        false
      ) {
        callback(new Error('信用代码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        name: [
          { required: true, message: '学校名称不得为空', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        credit: [
          { required: true, message: '信用代码不得为空', trigger: 'blur' },
          { validator: validateCredit, trigger: 'blur' }
        ],
        upDepart: [
          {
            required: true,
            message: '请选择上级机构',
            trigger: ['blur', 'change']
          }
        ],
        mode: [
          {
            required: true,
            message: '请选择所属学段',
            trigger: ['blur', 'change']
          }
        ],
        banxue: [
          {
            required: false,
            message: '请选择办学模式',
            trigger: ['blur', 'change']
          }
        ],
        type: [
          {
            required: true,
            message: '请选择办学性质',
            trigger: ['blur', 'change']
          }
        ]
      },
      props: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      submitting: false,
      form: {
        id: null,
        name: '',
        credit: '',
        upDepart: '',
        mode: '',
        banxue: '',
        type: 1
      },
      upDeparts: [],
      modes: [
        {
          name: '小学',
          value: 1
        },
        {
          name: '初中',
          value: 2
        },
        {
          name: '高中',
          value: 3
        }
      ],
      banxues: [
        {
          name: '九年一贯制',
          value: 4,
          disabled: false
        },
        {
          name: '十二年一贯制',
          value: 5,
          disabled: false
        },
        {
          name: '完全中学',
          value: 6,
          disabled: false
        },
        {
          name: '教学点',
          value: 7,
          disabled: false
        }
      ],
      isLastSuccessful: false
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible === true
      },
      set () {
        this.$emit('update:visible', false)
      }
    },
    editing () {
      return this.identify && this.identify.id > 0
    },
    editorText () {
      return this.identify && this.identify.id ? '编辑' : '添加'
    }
  },

  watch: {
    'form.mode': {
      handler (newVal, oldVal) {
        if (newVal) {
          if (!this.editing) {
            this.form.banxue = ''
          }
          if (newVal === 1) {
            this.banxues = [
              {
                name: '九年一贯制',
                value: 4,
                disabled: false
              },
              {
                name: '十二年一贯制',
                value: 5,
                disabled: false
              },
              {
                name: '完全中学',
                value: 6,
                disabled: true
              },
              {
                name: '教学点',
                value: 7,
                disabled: false
              },
              {
                name: '职教中心',
                value: 8,
                disabled: true
              }
            ]
          } else if (newVal === 3) {
            this.banxues = [
              {
                name: '九年一贯制',
                value: 4,
                disabled: true
              },
              {
                name: '十二年一贯制',
                value: 5,
                disabled: false
              },
              {
                name: '完全中学',
                value: 6,
                disabled: false
              },
              {
                name: '教学点',
                value: 7,
                disabled: false
              },
              {
                name: '职教中心',
                value: 8,
                disabled: false
              }
            ]
          } else {
            this.banxues = [
              {
                name: '九年一贯制',
                value: 4,
                disabled: false
              },
              {
                name: '十二年一贯制',
                value: 5,
                disabled: false
              },
              {
                name: '完全中学',
                value: 6,
                disabled: false
              },
              {
                name: '教学点',
                value: 7,
                disabled: false
              },
              {
                name: '职教中心',
                value: 8,
                disabled: true
              }
            ]
          }
        } else {
          this.banxues = [
            {
              name: '九年一贯制',
              value: 4,
              disabled: false
            },
            {
              name: '十二年一贯制',
              value: 5,
              disabled: false
            },
            {
              name: '完全中学',
              value: 6,
              disabled: false
            },
            {
              name: '教学点',
              value: 7,
              disabled: false
            },
              {
                name: '职教中心',
                value: 8,
                disabled: true
              }
          ]
        }
      }
    }
  },

  mounted () {},
  methods: {
    handleOpen () {
      this.$refs.form && this.$refs.form.resetFields()
      this.submitting = false
      // 获取上级机构
      this.$xhrGet(`/acc/institutions`).then(rs => {
        this.upDeparts = rs.data
      })
      this.form.name = this.identify.name || ''
      this.form.credit = this.identify.creditCode || ''
      this.form.upDepart =
        (this.identify.institution && this.identify.institution.value) || ''
      this.form.mode = this.identify.schoolStage || ''
      this.form.banxue = this.identify.schoolMode || ''
      this.form.type = this.identify.schoolType || 1
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    xhrUpdate () {
      let realFormData = {
        name: this.form.name === this.identify.name ? null : this.form.name,
        creditCode:
          this.form.credit === this.identify.creditCode
            ? null
            : this.form.credit,
        institutionId:
          this.form.upDepart === this.identify.institution.value
            ? null
            : this.form.upDepart,
        schoolStage:
          this.form.mode === this.identify.schoolStage ? null : this.form.mode,
        schoolMode:
          this.form.banxue === this.identify.schoolStage
            ? null
            : this.form.banxue,
        type:
          this.form.type === this.identify.schoolType ? null : this.form.type
      }
      if (__.isObjectPropertiesAllNull(realFormData)) {
        this.submitting = false
        this.$message.error('请修改信息后提交')
        return
      }
      this.$xhrPut(`/acc/schools/${this.identify.id}`, realFormData).then(
        rs => {
          if (!rs) {
            this.submitting = false
          }
          if (rs.code === 'SUCCESS') {
            this.isLastSuccessful = true
            this.closeDialog()
          } else {
            this.submitting = false
            if (rs.code === 'name_exists') {
              this.$message.error('学校名称已存在')
            } else if (rs.code === 'duplicate_creditCode') {
              this.$message.error('信用代码已存在')
            } else if (rs.code === 'PARAM_ERROR') {
              this.$message.error('请检查输入')
            }
          }
        }
      )
    },

    xhrAdd () {
      let realFormData = {
        name: this.form.name,
        creditCode: this.form.credit,
        institutionId: this.form.upDepart,
        schoolStage: this.form.mode,
        schoolMode: this.form.banxue,
        type: this.form.type
      }
      this.$xhrPost(`/acc/schools`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
          if (rs.code === 'name_exists') {
            this.$message.error('学校名称已存在')
          } else if (rs.code === 'duplicate_creditCode') {
            this.$message.error('信用代码已存在')
          } else if (rs.code === 'PARAM_ERROR') {
            this.$message.error('请检查输入')
          }
        }
      })
    },

    submitForm (formName) {
      this.submitting = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editing ? this.xhrUpdate() : this.xhrAdd()
        } else {
          this.$message.error('请检查输入')
          this.submitting = false
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/operate/SchoolEditor.vue